export const styles = {
  downloadButton: {
    marginRight: 10,
  },
};
